var _excluded = ["forwardRef", "children"],
  _excluded2 = ["forwardRef", "children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useDialogHelpers from '../../hooks/useDialogHelpers';
import './style.scss';
var Dialog = function Dialog(props) {
  var id = props.id,
    children = props.children,
    isOpen = props.isOpen,
    closeFunction = props.closeFunction,
    showCloseButton = props.showCloseButton,
    closeButtonText = props.closeButtonText,
    showCloseIcon = props.showCloseIcon,
    closeIcon = props.closeIcon,
    dialogLabel = props.dialogLabel,
    portalTarget = props.portalTarget,
    disableClosers = props.disableClosers,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$titleComponent = props.titleComponent,
    titleComponent = _props$titleComponent === void 0 ? null : _props$titleComponent,
    _props$wrapperCompone = props.wrapperComponent,
    wrapperComponent = _props$wrapperCompone === void 0 ? Dialog.Wrapper : _props$wrapperCompone,
    _props$backdropCompon = props.backdropComponent,
    backdropComponent = _props$backdropCompon === void 0 ? Dialog.Wrapper : _props$backdropCompon;
  var wrapper = useRef(null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var TitleComponent = titleComponent;
  var WrapperComponent = wrapperComponent;
  var BackdropComponent = backdropComponent;
  var _useDialogHelpers = useDialogHelpers({
      id: id,
      wrapperElement: wrapper,
      closeFunction: closeFunction,
      isOpen: isOpen,
      disableClosers: disableClosers
    }),
    labelId = _useDialogHelpers.labelId,
    dialogHelpersProps = _useDialogHelpers.dialogHelpersProps,
    dialogId = _useDialogHelpers.id;
  if (!isOpen) return null;
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: classnames('Dialog', className),
    id: dialogId
  }, /*#__PURE__*/React.createElement(WrapperComponent, _extends({
    className: "Dialog__wrapper"
  }, dialogHelpersProps, {
    forwardRef: wrapper
  }), /*#__PURE__*/React.createElement("div", {
    id: labelId,
    className: "Dialog__sr-only"
  }, dialogLabel), TitleComponent && /*#__PURE__*/React.createElement("div", {
    className: "Dialog__title"
  }, /*#__PURE__*/React.createElement(TitleComponent, null)), showCloseIcon && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "Dialog__closeicon",
    "aria-label": t('general.close', 'Close'),
    onClick: closeFunction
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon ".concat(closeIcon)
  })), /*#__PURE__*/React.createElement(RemoveScroll, {
    className: "Dialog__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Dialog__content"
  }, children), showCloseButton && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "Dialog__closebutton",
    onClick: closeFunction
  }, closeButtonText))), /*#__PURE__*/React.createElement(BackdropComponent, {
    className: "Dialog__backdrop",
    "aria-label": t('general.close', 'Close')
  })), portalTarget);
};
Dialog.propTypes = {
  id: PropTypes.string,
  title: PropTypes.element,
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool,
  closeFunction: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closeButtonText: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  closeIcon: PropTypes.string,
  dialogLabel: PropTypes.string,
  portalTarget: PropTypes.element,
  disableClosers: PropTypes.bool
};
Dialog.defaultProps = {
  id: undefined,
  title: null,
  showCloseButton: false,
  closeButtonText: 'Close',
  showCloseIcon: false,
  closeIcon: 'icon-cross',
  dialogLabel: 'dialog',
  isOpen: false,
  closeFunction: null,
  portalTarget: typeof document !== 'undefined' ? document.body : null,
  disableClosers: false
};
Dialog.Wrapper = function (_ref) {
  var forwardRef = _ref.forwardRef,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: forwardRef
  }, props), children);
};
Dialog.Backdrop = function (_ref2) {
  var forwardRef = _ref2.forwardRef,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: forwardRef
  }, props), children);
};
export default Dialog;